import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap";
import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {FlightMode} from "../../FlightMode";
import {FlightModeSound} from "../../misc/FlightModeSound";
import {FreespinsIntro} from "../FreespinsIntro";
import {FreespinsOutro} from "../FreespinsOutro";
import {MaxWin} from "../MaxWin";
import {ExtraSpin} from "../ExtraSpin";

export class FlightModeTransitionScreenView extends PIXI.Container implements StageLayer {

    protected button:ContinueButton;
    buttonSound:string;
    private clickCallback?:Function;

    public freespinsIntro:FreespinsIntro;
    public freespinsOutro:FreespinsOutro;
    public maxWin:MaxWin;
    public extraSpin:ExtraSpin;

    constructor(name?:string) {
        super();

        this.name = name ? name : "FlightModeTransitionScreenView";

        this.freespinsIntro = new FreespinsIntro();
        this.addChild(this.freespinsIntro);
        this.freespinsOutro = new FreespinsOutro();
        this.addChild(this.freespinsOutro);
        this.maxWin = new MaxWin();
        this.addChild(this.maxWin);
        this.extraSpin = new ExtraSpin();
        this.extraSpin.position.set(0, 20);
        this.addChild(this.extraSpin);

        this.button = new ContinueButton();
        this.button.addClickCallback(() => this.onButtonClick());
        this.button.position.set(360, 610);
        this.button.pivot.set(this.button.width * 0.5, this.button.height * 0.5);
        this.button.enable(false);
        this.button.alpha = 0;
        this.addChild(this.button);

        this.onResize();
    }

    onResize():void {
        if (NolimitApplication.isLandscape) {
            this.button.position.set(360, 610);
        } else {
            this.button.position.set(360, NolimitApplication.screenBounds.bottom - 250);
        }
        this.freespinsIntro.darkening.width = NolimitApplication.screenBounds.width;
        this.freespinsIntro.darkening.height = NolimitApplication.screenBounds.height;
        this.freespinsOutro.darkening.width = NolimitApplication.screenBounds.width;
        this.freespinsOutro.darkening.height = NolimitApplication.screenBounds.height;
        this.maxWin.darkening.width = NolimitApplication.screenBounds.width;
        this.maxWin.darkening.height = NolimitApplication.screenBounds.height;
    }

    private onButtonClick() {
        this.button.enable(false);
        if (this.clickCallback == undefined) {
            throw new Error("No button click callback");
        }
        this.clickCallback();
        FlightMode.soundPlayer.playSound(this.buttonSound);
        gsap.to(this.button, {duration:0.2, alpha:0});
        delete this.clickCallback;
    }

    public enableButton(cb:Function, sound = FlightModeSound.CONTINUE_BUTTON):gsap.core.Timeline {
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.buttonSound = sound;
            this.clickCallback = cb;
            this.button.enable(true);
        });
        tl.add(gsap.to(this.button, {duration:0.2, alpha:1}));
        return tl;
    }
}